import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
var maxSuggestionCounts = {
    people: 4,
    folder: 3,
    search: 0,
    category: 2,
    group: 2,
};
var maxSuggestionCountsWithFavoriteSearch = {
    people: 3,
    folder: 2,
    search: 2,
    category: 2,
    group: 2,
};
export default function getMaxFavoriteSuggestionCounts() {
    return isMailFeatureEnabled('tri-favoriteSearch')
        ? maxSuggestionCountsWithFavoriteSearch
        : maxSuggestionCounts;
}
//# sourceMappingURL=getMaxFavoriteSuggestionCounts.js.map